import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolBarContext = /*#__PURE__*/createContext({
  use: undefined
});
export const useToolBarContext = () => {
  const toolBarContext = useContext(ToolBarContext);
  return toolBarContext;
};
export const isInFilledToolbar = toolbarContext => {
  const isFilledToolbar = (toolbarContext === null || toolbarContext === void 0 ? void 0 : toolbarContext.use) === 'default' || (toolbarContext === null || toolbarContext === void 0 ? void 0 : toolbarContext.use) === 'dark';
  return isFilledToolbar;
};
export const useIsInFilledToolbar = () => {
  const toolbarContext = useToolBarContext();
  return isInFilledToolbar(toolbarContext);
};
export const withToolBarContext = WrappedComponent => {
  const ComponentWithToolBarContext = props => {
    const toolBarContext = useToolBarContext();
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      toolBarContext: toolBarContext
    }));
  };
  ComponentWithToolBarContext.displayName = `withToolBarContext(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return ComponentWithToolBarContext;
};